import React, { Component } from 'react';
import styled from '@emotion/styled';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { OverlayMenuToggleBar } from './OverlayMenuToggleBar';
import { OverlayMenuContent } from './OverlayMenuContent';
import { Z_INDEX_MENU_OVERLAY } from '../../../styles';
import { ISiteSectionEntry } from '../../../api/contentful/types';
import { IEnrichedPageEntry } from '../../../../app/pages/domain/models/IEnrichedPageEntry';

const StyledMenuOverlay = styled(DialogOverlay)`
	&[data-reach-dialog-overlay] {
		z-index: ${Z_INDEX_MENU_OVERLAY};
		background: #fff;
		overflow: hidden;
	}
`;

const StyledMenuContent = styled(DialogContent)`
	&[data-reach-dialog-content] {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		background: #fff;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
`;

interface IOverlayNavigationProps {
	isFixed: boolean;
	// eslint-disable-next-line react/no-unused-prop-types
	siteSections: ISiteSectionEntry[];
	// eslint-disable-next-line react/no-unused-prop-types
	currentSiteSection?: ISiteSectionEntry;
	// eslint-disable-next-line react/no-unused-prop-types
	currentPage?: IEnrichedPageEntry;
}

interface IOverlayNavigationState {
	isMenuOpen: boolean;
}

export class OverlayMenu extends Component<
	IOverlayNavigationProps,
	IOverlayNavigationState
> {
	public state = {
		isMenuOpen: false,
	};

	private onClickToggle = () => {
		this.setState(({ isMenuOpen }) => ({ isMenuOpen: !isMenuOpen }));
	};

	public render() {
		const { isFixed } = this.props;
		const { isMenuOpen } = this.state;

		return (
			<>
				<OverlayMenuToggleBar
					isFixed={isFixed}
					isMenuOpen={false}
					onClickToggle={this.onClickToggle}
				/>
				<StyledMenuOverlay isOpen={isMenuOpen} onDismiss={this.onClickToggle}>
					<StyledMenuContent aria-label="Navigation menu">
						<OverlayMenuToggleBar
							isFixed={false}
							isMenuOpen
							onClickToggle={this.onClickToggle}
						/>
						<OverlayMenuContent onClick={this.onClickToggle} />
					</StyledMenuContent>
				</StyledMenuOverlay>
			</>
		);
	}
}
